import axios from "axios"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { CityArrayAdd, ClearSelectedCity, SelectCity } from "../../Reducer/CitySlice"
import { AddArticle } from "../../Reducer/ArticleSlice"
import { ClearSelectedMonthAR, MonthArrayAddAR, SelectMonthAR } from "../../Reducer/MonthSliceAR"
import { FaFilter, FaCheck, FaPencil, FaLockOpen, FaLock  } from "react-icons/fa6";
import { AddOneAdvanceReprot, changeBalanceBeginningMonthCash, changeBalanceBeginningMonthNonCash, changeBlockEdit } from "../../Reducer/AdvanceReprotsSlice"
import { addTypeArticleInAR, openEditAddedArticle } from "../../Reducer/AddArticleInARSlice"
import { setOpenAddArticleED } from "../../Reducer/ModalSlice"
import { roleId } from "../Constants/app"

function EnteringDataAR(){
    const CityArray = useSelector(state => state.CitySlice.CityArray)
    const SelectedCity = useSelector(state => state.CitySlice.SelectedCity)

    const User = useSelector(state => state.UserSlice.User)
    const Server = useSelector(state => state.UserSlice.Server)

    const MonthArrayAR = useSelector(state => state.MonthSliceAR.MonthArrayAR)
    const SelectedMonthAR = useSelector(state => state.MonthSliceAR.SelectedMonthAR)

    const AdvanceReportED = useSelector(state => state.AdvanceReprotsSlice.AdvanceReportED)

    const [SearchingCity, setSearchingCity] = useState()
    const [SearchingMonth, setSearchingMonth] = useState()
    const [openSearchingCity, setOpenSearchingCity] = useState(false)
    const [openSearchingMonth, setOpenSearchingMonth] = useState(false)
    const [openFilter, setOpenFilter] = useState(false)
    const [CancelTouch, setCancelTouch] = useState(false)
    const [isLoading, setLoading] = useState(true)
    const [isLoadingAdvanceReport, setLoadingAdvanceReport] = useState(true)
    const [isLoadingBalanceBeginningCash, setLoadingBalanceBeginningCash] = useState(true)
    const [isLoadingLocker, setLoadingLocker] = useState(true)
    const [VisibleIncome, setVisibleIncome] = useState(true)
    const [VisibleExpenditure, setVisibleExpenditure] = useState(true)
    const [VisibleCollection, setVisibleCollection] = useState(true)
    const [VisibleTransactionTypeCash, setVisibleTransactionTypeCash] = useState(true)
    const [VisibleTransactionTypeNonCash, setVisibleTransactionTypeNonCash] = useState(true)
    const [FilterArticles, setFilterArticles] = useState()
    const [BalanceBeginningCash, setBalanceBeginningCash] = useState('')    
    const [BalanceEndCash, setBalanceEndCash] = useState('')
    const [BalanceBeginningNonCash, setBalanceBeginningNonCash] = useState('')
    const [BalanceEndNonCash, setBalanceEndNonCash] = useState('')
    const [SelectTransactionType, setSelectTransactionType] = useState('Cash')
    const [IncomeCash, setIncomeCash] = useState('')
    const [ExpenditureCash, setExpenditureCash] = useState('')
    const [CollectionCash, setCollectionCash] = useState('')
    const [IncomeNonCash, setIncomeNonCash] = useState('')
    const [ExpenditureNonCash, setExpenditureNonCash] = useState('')
    const [IncomeTotal, setIncomeTotal] = useState('')
    const [ExpenditureTotal, setExpenditureTotal] = useState('')
    const [ModalDeleteCity, setModalDeleteCity] = useState(false)
    const [ModalDeleteMonth, setModalDeleteMonth] = useState(false)

    const dispatch = useDispatch()

    const getCity = async () =>  {
        var CityArrayChecked = []
        var CityCheck 
            await axios.get(Server + 'cities?_limit=-1', {
                headers: {
                    Authorization: 'Bearer ' + User.jwt,
                }
            })
            .then((response) => {
                if([roleId.admin, roleId.operatingDirector].includes(User.user.role.id)|| User.user.idCity === 'all')
                    {
                        dispatch(CityArrayAdd(response.data))
                        setSearchingCity(response.data)
                    }
                    else
                    {
                        CityCheck = response.data
                    }
                })
    
        if(![roleId.admin, roleId.operatingDirector].includes(User.user.role.id) && User.user.idCity !== 'all')
        {
            await User.user.idCity.map((el) => {
                CityCheck.map((a) => {
                    if(parseInt(a.id) === parseInt(el))
                    {
                        CityArrayChecked.push(a)
                    }
                    return(a)
                })
                return(el)
            })
            await dispatch(CityArrayAdd(CityArrayChecked))
            await setSearchingCity(CityArrayChecked)
        }
    }
    
    const getFilterArticles = async () => {
        let SortingArray = [...AdvanceReportED.Articles]
        const SortData = await SortingArray.sort((a , b) => {
            const getDateA = a.CreateAd.split('T')[0].split('-')
            const getDateB = b.CreateAd.split('T')[0].split('-')
            const chekDateA = getDateA[0] + '-' + getDateA[1].padStart(2, '0') + '-' + getDateA[2].padStart(2, '0')
            const chekDateB = getDateB[0] + '-' + getDateB[1].padStart(2, '0') + '-' + getDateB[2].padStart(2, '0')
            const dateA = new Date(chekDateA)
            const dateB = new Date(chekDateB)
            if(chekDateA === chekDateB)
                return b.id - a.id
            return dateB - dateA
        })

        let FilterCheck = SortData

        if([roleId.admin, roleId.operatingDirector, roleId.director].includes(User.user.role.id))
            await setFilterArticles(FilterCheck)

        if(User.user.role.id === roleId.accountant)
        {            
            setFilterArticles(FilterCheck.filter((el) => el.TransactionType === 'NonCash'))
        }

        if(User.user.role.id === roleId.manager)
        {            
            setFilterArticles(FilterCheck.filter((el) => el.TransactionType === 'Cash'))
        }
    }

    const getArticle = () => {
        axios.get(Server + 'articlesofmoneymovements?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            }
        })
        .then((response) => {
            dispatch(AddArticle(response.data))
        })
    }

    const getMonth = () => {
        axios.get(Server + 'monthforadvancereports?_limit=-1&_sort=id:DESC', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            }
        })
        .then((response) => {
            dispatch(MonthArrayAddAR(response.data))
            setSearchingMonth(response.data)
        })
    }

    const getData = async () => {
        await setLoading(false)
        await getCity()
        await getMonth()
        await getArticle()
        await setLoading(true)
    }

    useEffect(() => {
        getData()
        if(User.user.role.id === roleId.manager) setSelectTransactionType('Cash')
        if(User.user.role.id === roleId.accountant) setSelectTransactionType('NonCash')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(AdvanceReportED.Articles && SelectedCity.id !== 0 && SelectedMonthAR.id !== 0)
        {
            getFilterArticles()
            setBalanceBeginningCash(parseFloat(AdvanceReportED.BalanceBeginningMonthCash))    
            setBalanceBeginningNonCash(parseFloat(AdvanceReportED.BalanceBeginningMonthNonCash))   
            BalanceEnd()    
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [AdvanceReportED])

    const filteringArticles = async () => {        
        let SortingArray = [...AdvanceReportED.Articles]
        const SortData = await SortingArray.sort((a , b) => {
            const getDateA = a.CreateAd.split('T')[0].split('-')
            const getDateB = b.CreateAd.split('T')[0].split('-')
            const chekDateA = getDateA[0] + '-' + getDateA[1].padStart(2, '0') + '-' + getDateA[2].padStart(2, '0')
            const chekDateB = getDateB[0] + '-' + getDateB[1].padStart(2, '0') + '-' + getDateB[2].padStart(2, '0')
            const dateA = new Date(chekDateA)
            const dateB = new Date(chekDateB)
            if(chekDateA === chekDateB)
                return b.id - a.id
            return dateB - dateA
        })

        let FilterCheck = SortData

        if(!VisibleIncome)
            FilterCheck = FilterCheck.filter((el) => el.Type !== 'income')

        if(!VisibleExpenditure)
            FilterCheck = FilterCheck.filter((el) => el.Type !== 'expenditure')

        if(!VisibleCollection)
            FilterCheck = FilterCheck.filter((el) => el.Type !== 'collection')

        if(!VisibleTransactionTypeNonCash  || User.user.role.id === roleId.manager)
            FilterCheck = FilterCheck.filter((el) => el.TransactionType === 'Cash')

        if(!VisibleTransactionTypeCash || User.user.role.id === roleId.accountant)
            FilterCheck = FilterCheck.filter((el) => el.TransactionType === 'NonCash')

        setFilterArticles(FilterCheck)
    }

    const BalanceEnd = () => {
        let FilterCheckCash = []
        let IncomeCashCheck = 0
        let ExpenditureCashCheck = 0
        let CollectionCashCheck = 0
        let ResultCash = 0
        let FilterCheckNonCash = []
        let IncomeNonCashCheck = 0
        let ExpenditureNonCashCheck = 0
        let ResultNonCash = 0

        if(User.user.role.id !== roleId.accountant)
        {
            FilterCheckCash = AdvanceReportED.Articles.filter((el) => el.TransactionType === 'Cash')
            IncomeCashCheck = FilterCheckCash.filter((el) => el.Type === 'income').reduce((Sum, el) => Sum + parseFloat(el.Sum), 0).toFixed(2)
            ExpenditureCashCheck = FilterCheckCash.filter((el) => el.Type === 'expenditure').reduce((Sum, el) => Sum + parseFloat(el.Sum), 0).toFixed(2)
            CollectionCashCheck = FilterCheckCash.filter((el) => el.Type === 'collection').reduce((Sum, el) => Sum + parseFloat(el.Sum), 0).toFixed(2)
            ResultCash = (parseFloat(AdvanceReportED.BalanceBeginningMonthCash) + parseFloat(IncomeCashCheck) + parseFloat(CollectionCashCheck) - parseFloat(ExpenditureCashCheck)).toFixed(2)
            setBalanceEndCash(ResultCash)
                if(ResultCash !== AdvanceReportED.BalanceEndMonthCash)
                {
                    axios.put(Server + 'cityadvancereports/' + AdvanceReportED.id, {
                        BalanceEndMonthCash: ResultCash,
                      }, {
                        headers: {
                          Authorization: 'Bearer ' + User.jwt,
                        },
                      })
                }
            setIncomeCash(IncomeCashCheck)
            setExpenditureCash(ExpenditureCashCheck)
            setCollectionCash(CollectionCashCheck)
        }

        if(User.user.role.id !== roleId.manager)
        {
            FilterCheckNonCash = AdvanceReportED.Articles.filter((el) => el.TransactionType === 'NonCash')
            IncomeNonCashCheck = FilterCheckNonCash.filter((el) => el.Type === 'income').reduce((Sum, el) => Sum + parseFloat(el.Sum), 0).toFixed(2)
            ExpenditureNonCashCheck = FilterCheckNonCash.filter((el) => el.Type === 'expenditure').reduce((Sum, el) => Sum + parseFloat(el.Sum), 0).toFixed(2)
            ResultNonCash = (parseFloat(AdvanceReportED.BalanceBeginningMonthNonCash) + parseFloat(IncomeNonCashCheck) - parseFloat(ExpenditureNonCashCheck)).toFixed(2)
            setBalanceEndNonCash(ResultNonCash)
                if(ResultNonCash !== AdvanceReportED.BalanceEndMonthNonCash)
                {
                    axios.put(Server + 'cityadvancereports/' + AdvanceReportED.id, {
                        BalanceEndMonthNonCash: ResultNonCash,
                      }, {
                        headers: {
                          Authorization: 'Bearer ' + User.jwt,
                        },
                      })
                }
            setIncomeNonCash(IncomeNonCashCheck)
            setExpenditureNonCash(ExpenditureNonCashCheck)
            setIncomeTotal((parseFloat(IncomeCashCheck) + parseFloat(IncomeNonCashCheck)).toFixed(2))
            setExpenditureTotal((parseFloat(ExpenditureCashCheck) + parseFloat(ExpenditureNonCashCheck)).toFixed(2))
        }
    }

    const handleDeleteCity = async (event) => {
        if(event.type === 'touchend')
            event.preventDefault()

        document.getElementById('SearchingInputAR City').value = ''
        document.getElementById('SearchingInputAR City').defaultValue = ''

        await axios.get(Server + 'staff?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
            params:{
                idCity: parseInt(SelectedCity.id)
            }})
            .then((response) =>{
                axios.get(Server + 'staffofthemonths?_limit=-1', {
                    headers: {
                        Authorization: 'Bearer ' + User.jwt,
                    },
                    params:{
                        idStaff: parseInt(response.data.id)
                    }})
                    .then((res) =>{
                        res.data.map((el) => {
                            return(axios.delete(Server + 'staffofthemonth/' + el.id, {
                                headers: {
                                    Authorization: 'Bearer ' + User.jwt,
                                }
                            }))
                        })
                        
                    })
                response.data.map((el) => {
                    return(
                        axios.delete(Server + 'staff/' + el.id, {
                            headers: {
                                Authorization: 'Bearer ' + User.jwt,
                            }
                        })
                    )
                })       
                
            })
        
        await axios.get(Server + 'citiesrevenues?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
            params:{
                idCity: parseInt(SelectedCity.id)
            }})
            .then((response) =>{
                response.data.map((el) => {
                    return(
                        axios.delete(Server + 'citiesrevenues/' + el.id, {
                            headers: {
                                Authorization: 'Bearer ' + User.jwt,
                            }
                        })
                    )
                })
            })
       
        await axios.get(Server + 'cityadvancereports?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
            params:{
                idCity: parseInt(SelectedCity.id)
            }}) 
            .then((response) =>{
                response.data.map((el) => {
                    return(
                        axios.delete(Server + 'cityadvancereports/' + el.id, {
                            headers: {
                                Authorization: 'Bearer ' + User.jwt,
                            }
                        })
                    )
                })
               
            })                

        await axios.delete(Server + 'cities/' + SelectedCity.id, {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        })
        dispatch(ClearSelectedCity())

        await getCity()
        
        setModalDeleteCity(false)
    }

    const handleDeleteMonth = async (event) => {
        if(event.type === 'touchend')
            event.preventDefault()        

        document.getElementById('SearchingInputAR Month').value = ''
        document.getElementById('SearchingInputAR Month').defaultValue = ''

        await axios.get(Server + 'cityadvancereports?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
            params:{
                MonthValue: parseInt(SelectedMonthAR.MonthValue),
                YearValue: parseInt(SelectedMonthAR.YearValue),
            }})
            .then((response) =>{
                response.data.map((el) => {
                    return(
                        axios.delete(Server + 'cityadvancereports/' + el.id, {
                            headers: {
                                Authorization: 'Bearer ' + User.jwt,
                            }
                        })
                    )
                })
            })

        await axios.delete(Server + 'monthforadvancereports/' + SelectedMonthAR.id, {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        })
        dispatch(ClearSelectedMonthAR())

        await getCity()
        await getMonth()

        setModalDeleteMonth(false)
    }

    useEffect(() => {
        if(AdvanceReportED.Articles && SelectedCity.id !== 0 && SelectedMonthAR.id !== 0) filteringArticles();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [VisibleIncome, VisibleCollection, VisibleExpenditure, VisibleTransactionTypeNonCash, VisibleTransactionTypeCash, AdvanceReportED])

        if(!isLoading)
        return(
            <div
            className="ModalGlobalDiv"
            >
                <div
                className="BigSpin"
                />
            </div>
        )


        return(
            <div
            className="ModalGlobalDiv"
            onClick={(() => {
                setOpenFilter(false)
                setOpenSearchingCity(false)
                setSearchingCity(CityArray)
                document.getElementById('SearchingInputAR City').value = document.getElementById('SearchingInputAR City').defaultValue
                setOpenSearchingMonth(false)
                setSearchingMonth(MonthArrayAR)
                document.getElementById('SearchingInputAR Month').value = document.getElementById('SearchingInputAR Month').defaultValue
            })}
            onTouchStart={() => {
                setCancelTouch(false)
            }}
            onTouchMove={() => {
                setCancelTouch(true)
            }}
            onTouchCancel={() => {
                setCancelTouch(true)
            }}
            onTouchEnd={((event) => {
                event.preventDefault()
                if(!CancelTouch)
                {
                    setOpenFilter(false)
                    setOpenSearchingCity(false)
                    setSearchingCity(CityArray)
                    document.getElementById('SearchingInputAR City').value = document.getElementById('SearchingInputAR City').defaultValue
                    setOpenSearchingMonth(false)
                    setSearchingMonth(MonthArrayAR)
                    document.getElementById('SearchingInputAR Month').value = document.getElementById('SearchingInputAR Month').defaultValue    
                    document.getElementById('SearchingInputAR City').blur()
                    document.getElementById('SearchingInputAR Month').blur()
                }
            })}
            >
                <div
                className="ARMainDiv"
                >
                    <div
                    className="HeadAR"
                    >
                        <div
                        className="HeadAR Under InputsDiv"
                        >
                            <div>
                                <input
                                className="SearchingInputAR EnteringData"
                                placeholder="Выбор филиала"
                                id='SearchingInputAR City'
                                defaultValue={SelectedCity.id !== 0 ? SelectedCity.City + ' ' + SelectedCity.Adress : ''}
                                onClick={((event) => {     
                                    event.stopPropagation()                          
                                    document.getElementById('SearchingInputAR City').value = ''
                                    setOpenSearchingMonth(false)
                                    setSearchingMonth(MonthArrayAR)
                                    document.getElementById('SearchingInputAR Month').value = document.getElementById('SearchingInputAR Month').defaultValue
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()  
                                    if(!CancelTouch)
                                    {
                                        event.stopPropagation()
                                        document.getElementById('SearchingInputAR Month').blur()
                                        document.getElementById('SearchingInputAR City').value = ''
                                        document.getElementById('SearchingInputAR City').focus()
                                        setOpenSearchingMonth(false)
                                        setSearchingMonth(MonthArrayAR)
                                        document.getElementById('SearchingInputAR Month').value = document.getElementById('SearchingInputAR Month').defaultValue
                                    }
                                })}
                                onFocus={(() => {
                                    setOpenSearchingCity(true)
                                })}
                                onChange={((e) => {
                                    var Val = e.target.value.toLowerCase()
                                    setSearchingCity(CityArray.filter((el) => 
                                        (el.City + ' ' + el.Adress).toLowerCase().includes(Val)
                                    ))
                                })}
                                />
                                {openSearchingCity && 
                                <div
                                className="SearchingARMainDiv"
                                >
                                    <div
                                    className="SearchingARContainer EnteringData"
                                    >
                                        {SearchingCity.map((el) => 
                                        <button
                                        key={el.id}
                                        className="SearchingAROneCity"
                                        onClick={(async (event) => {
                                            event.stopPropagation()
                                            await dispatch(SelectCity(el))  
                                            setOpenSearchingCity(false)
                                            setSearchingCity(CityArray)
                                            document.getElementById('SearchingInputAR City').value = document.getElementById('SearchingInputAR City').defaultValue                                      
                                            if(SelectedMonthAR.id !== 0)
                                            {
                                                setLoadingAdvanceReport(false)
                                                await axios.get(Server + 'cityadvancereports?_limit=-1', {
                                                    headers: {
                                                        Authorization: 'Bearer ' + User.jwt,
                                                    },
                                                    params:{
                                                        idCity: parseInt(el.id),
                                                        MonthValue: parseInt(SelectedMonthAR.MonthValue),
                                                        YearValue: parseInt(SelectedMonthAR.YearValue)
                                                    }
                                                })
                                                .then(async (response) => {
                                                    await dispatch(AddOneAdvanceReprot(response.data))
                                                    setLoadingAdvanceReport(true)
                                                })
                                            }
                                        })}
                                        onTouchStart={() => {
                                            setCancelTouch(false)
                                        }}
                                        onTouchMove={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchCancel={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchEnd={(async (event) => {
                                            event.preventDefault()
                                            if(!CancelTouch)
                                            {
                                                event.stopPropagation()
                                                await dispatch(SelectCity(el))                                        
                                                setOpenSearchingCity(false)
                                                setSearchingCity(CityArray)
                                                document.getElementById('SearchingInputAR City').blur()
                                                document.getElementById('SearchingInputAR City').value = document.getElementById('SearchingInputAR City').defaultValue
                                                if(SelectedMonthAR.id !== 0)
                                                {
                                                    setLoadingAdvanceReport(false)
                                                    await axios.get(Server + 'cityadvancereports?_limit=-1', {
                                                        headers: {
                                                            Authorization: 'Bearer ' + User.jwt,
                                                        },
                                                        params:{
                                                            idCity: parseInt(el.id),
                                                            MonthValue: parseInt(SelectedMonthAR.MonthValue),
                                                            YearValue: parseInt(SelectedMonthAR.YearValue)
                                                        }
                                                    })
                                                    .then(async (response) => {
                                                        await dispatch(AddOneAdvanceReprot(response.data))
                                                        setLoadingAdvanceReport(true)
                                                    })
                                                }
                                            }
                                        })}
                                        >
                                            {el.City + ' ' + el.Adress}
                                        </button>
                                        )}
                                    </div>
                                </div>
                                }
                            </div>
                            <div>
                                <input
                                className="SearchingInputAR EnteringData"
                                id="SearchingInputAR Month" 
                                placeholder="Выбор месяца"
                                defaultValue={SelectedMonthAR.Name}
                                onClick={((event) => {
                                    event.stopPropagation()
                                    document.getElementById('SearchingInputAR Month').value = ''
                                    setOpenSearchingCity(false)
                                    setSearchingCity(CityArray)
                                    document.getElementById('SearchingInputAR City').value = document.getElementById('SearchingInputAR City').defaultValue
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()  
                                    if(!CancelTouch)
                                    {
                                        event.stopPropagation()
                                        document.getElementById('SearchingInputAR City').blur()
                                        document.getElementById('SearchingInputAR Month').value = ''
                                        document.getElementById('SearchingInputAR Month').focus()
                                        setOpenSearchingCity(false)
                                        setSearchingCity(CityArray)
                                        document.getElementById('SearchingInputAR City').value = document.getElementById('SearchingInputAR City').defaultValue
        
                                    }
                                })}
                                onFocus={(() => {
                                    setOpenSearchingMonth(true)
                                })}
                                onChange={((e) => {
                                    var Val = e.target.value.toLowerCase()
                                    setSearchingMonth(MonthArrayAR.filter((el) => 
                                        el.Name.toLowerCase().includes(Val)
                                    ))
                                })}
                                />
                                {openSearchingMonth && 
                                <div
                                className="SearchingARMainDiv"
                                >
                                    <div
                                    className="SearchingARContainer EnteringData"
                                    >
                                        {SearchingMonth.map((el) => 
                                        <button
                                        key={el.id}
                                        className="SearchingAROneCity"
                                        onClick={(async (event) => {
                                            await dispatch(SelectMonthAR(el))
                                            event.stopPropagation()
                                            setOpenSearchingMonth(false)
                                            setSearchingMonth(MonthArrayAR)
                                            document.getElementById('SearchingInputAR Month').value = document.getElementById('SearchingInputAR Month').defaultValue
                                            if(SelectedCity.id !== 0)
                                            {
                                                setLoadingAdvanceReport(false)
                                                await axios.get(Server + 'cityadvancereports?_limit=-1', {
                                                    headers: {
                                                        Authorization: 'Bearer ' + User.jwt,
                                                    },
                                                    params:{
                                                        idCity: parseInt(SelectedCity.id),
                                                        MonthValue: parseInt(el.MonthValue),
                                                        YearValue: parseInt(el.YearValue)
                                                    }
                                                })
                                                .then(async (response) => {
                                                    await dispatch(AddOneAdvanceReprot(response.data))
                                                    setLoadingAdvanceReport(true)
                                                })
                                            }
                                        })}
                                        onTouchStart={() => {
                                            setCancelTouch(false)
                                        }}
                                        onTouchMove={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchCancel={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchEnd={(async (event) => {
                                            event.preventDefault()
                                            if(!CancelTouch)
                                            {
                                                await dispatch(SelectMonthAR(el))
                                                event.stopPropagation()
                                                setOpenSearchingMonth(false)
                                                setSearchingMonth(MonthArrayAR)
                                                document.getElementById('SearchingInputAR Month').blur()
                                                document.getElementById('SearchingInputAR Month').value = document.getElementById('SearchingInputAR Month').defaultValue
                                                if(SelectedCity.id !== 0)
                                                {
                                                    setLoadingAdvanceReport(false)
                                                    await axios.get(Server + 'cityadvancereports?_limit=-1', {
                                                        headers: {
                                                            Authorization: 'Bearer ' + User.jwt,
                                                        },
                                                        params:{
                                                            idCity: parseInt(SelectedCity.id),
                                                            MonthValue: parseInt(el.MonthValue),
                                                            YearValue: parseInt(el.YearValue)
                                                        }
                                                    })
                                                    .then(async (response) => {
                                                        await dispatch(AddOneAdvanceReprot(response.data))
                                                        setLoadingAdvanceReport(true)
                                                    })
                                                }
                                            }
                                        })}
                                        >
                                            {el.Name}
                                        </button>
                                        )}
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                        <div
                        className="HeadAR Under"
                        >
                        <div>
                            {(!VisibleIncome || !VisibleExpenditure || !VisibleCollection || !VisibleTransactionTypeCash || !VisibleTransactionTypeNonCash) &&
                                <div
                                className="FilterCircleDiv"
                                >
                                    <div className="FilterCircle"/>
                                </div>
                            }
                            <button
                            className="FilterButtonAR"
                            onClick={((event) => {
                                event.stopPropagation(); 
                                setOpenFilter(!openFilter)
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                event.stopPropagation();    
                                if(!CancelTouch)
                                {
                                    setOpenFilter(!openFilter)
                                }
                            })}
                            >                               
                                <FaFilter />
                            </button>
                            {openFilter &&
                            <div
                            className="FilterARMainDiv"
                            >
                                <div
                                className="FilterARContainer"
                                >
                                    <button
                                    className="CheckBoxEnteringDataAR"
                                    onClick={((event) => {
                                        event.stopPropagation(); 
                                        setVisibleIncome(!VisibleIncome)
                                    })}
                                    onTouchStart={() => {
                                        setCancelTouch(false)
                                    }}
                                    onTouchMove={() => {
                                        setCancelTouch(true)
                                    }}
                                    onTouchCancel={() => {
                                        setCancelTouch(true)
                                    }}
                                    onTouchEnd={((event) => {
                                        event.preventDefault()
                                        event.stopPropagation();    
                                        if(!CancelTouch)
                                        {
                                            setVisibleIncome(!VisibleIncome)
                                        }
                                    })}
                                    >
                                        <div
                                        className={VisibleIncome ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}
                                        >
                                            <FaCheck className={VisibleIncome ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>
                                        </div>
                                        <div>
                                            Показать доход
                                        </div>
                                    </button>
                                    <button
                                    className="CheckBoxEnteringDataAR"
                                    onClick={((event) => {
                                        event.stopPropagation(); 
                                        setVisibleExpenditure(!VisibleExpenditure)
                                    })}
                                    onTouchStart={() => {
                                        setCancelTouch(false)
                                    }}
                                    onTouchMove={() => {
                                        setCancelTouch(true)
                                    }}
                                    onTouchCancel={() => {
                                        setCancelTouch(true)
                                    }}
                                    onTouchEnd={((event) => {
                                        event.preventDefault()
                                        event.stopPropagation();    
                                        if(!CancelTouch)
                                        {
                                            setVisibleExpenditure(!VisibleExpenditure)
                                        }
                                    })}
                                    >
                                        <div
                                        className={VisibleExpenditure ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}
                                        >
                                            <FaCheck className={VisibleExpenditure ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>
                                        </div>
                                        <div>
                                            Показать расход
                                        </div>
                                    </button>
                                    <button
                                    className="CheckBoxEnteringDataAR"
                                    onClick={((event) => {
                                        event.stopPropagation(); 
                                        setVisibleCollection(!VisibleCollection)
                                    })}
                                    onTouchStart={() => {
                                        setCancelTouch(false)
                                    }}
                                    onTouchMove={() => {
                                        setCancelTouch(true)
                                    }}
                                    onTouchCancel={() => {
                                        setCancelTouch(true)
                                    }}
                                    onTouchEnd={((event) => {
                                        event.preventDefault()
                                        event.stopPropagation();    
                                        if(!CancelTouch)
                                        {
                                            setVisibleCollection(!VisibleCollection)
                                        }
                                    })}
                                    >
                                        <div
                                        className={VisibleCollection ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}
                                        >
                                            <FaCheck className={VisibleCollection ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>
                                        </div>
                                        <div>
                                            Показать инкассацию
                                        </div>
                                    </button>
                                    {[roleId.admin, roleId.operatingDirector, roleId.director].includes(User.user.role.id) &&
                                    <>
                                        <button
                                        className="CheckBoxEnteringDataAR FirstCash"
                                        onClick={((event) => {
                                            event.stopPropagation(); 
                                            setVisibleTransactionTypeCash(!VisibleTransactionTypeCash)
                                        })}
                                        onTouchStart={() => {
                                            setCancelTouch(false)
                                        }}
                                        onTouchMove={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchCancel={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchEnd={((event) => {
                                            event.preventDefault()
                                            event.stopPropagation();    
                                            if(!CancelTouch)
                                            {
                                                setVisibleTransactionTypeCash(!VisibleTransactionTypeCash)
                                            }
                                        })}
                                        >
                                            <div
                                            className={VisibleTransactionTypeCash ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}
                                            >
                                                <FaCheck className={VisibleTransactionTypeCash ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>
                                            </div>
                                            <div>
                                                Показать операции нал.
                                            </div>
                                        </button>
                                        <button
                                        className="CheckBoxEnteringDataAR"
                                        onClick={((event) => {
                                            event.stopPropagation(); 
                                            setVisibleTransactionTypeNonCash(!VisibleTransactionTypeNonCash)
                                        })}
                                        onTouchStart={() => {
                                            setCancelTouch(false)
                                        }}
                                        onTouchMove={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchCancel={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchEnd={((event) => {
                                            event.preventDefault()
                                            event.stopPropagation();    
                                            if(!CancelTouch)
                                            {
                                                setVisibleTransactionTypeNonCash(!VisibleTransactionTypeNonCash)
                                            }
                                        })}
                                        >
                                            <div
                                            className={VisibleTransactionTypeNonCash ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}
                                            >
                                                <FaCheck className={VisibleTransactionTypeNonCash ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>
                                            </div>
                                            <div>
                                                Показать операции безнал.
                                            </div>
                                        </button>
                                    </>
                                }
                                </div>
                            </div>
                            }                        
                        </div>
                        {SelectedCity.id !== 0 && SelectedMonthAR.id !== 0 && AdvanceReportED &&
                            <button
                            className="FilterButtonAR"
                            onClick={(async () => {
                                if(![roleId.admin, roleId.operatingDirector].includes(User.user.role.id))
                                    return(alert('У вас недостаточно прав для данного действия'))

                                if(!isLoadingLocker)
                                    return(false)

                                setLoadingLocker(false)
                                await axios.put(Server + 'cityadvancereports/' + AdvanceReportED.id, {
                                    BlockEdit: !AdvanceReportED.BlockEdit,
                                }, {
                                    headers: {
                                    Authorization: 'Bearer ' + User.jwt,
                                    },
                                })
                                .then(() => {
                                    dispatch(changeBlockEdit(!AdvanceReportED.BlockEdit))
                                })
                                .catch(() => {
                                    alert('Ошибка сохранения данных о остатке на начало месяца, повторите ввод.')                                    
                                })
                                .finally(() => {
                                    setLoadingLocker(true)
                                })
                            })}    
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={(async (event) => {
                                event.preventDefault()   
                                if(!CancelTouch)
                                {
                                    if(![roleId.admin, roleId.operatingDirector].includes(User.user.role.id))
                                        return(alert('У вас недостаточно прав для данного действия'))
    
                                    if(!isLoadingLocker)
                                        return(false)
    
                                    setLoadingLocker(false)
                                    await axios.put(Server + 'cityadvancereports/' + AdvanceReportED.id, {
                                        BlockEdit: !AdvanceReportED.BlockEdit,
                                    }, {
                                        headers: {
                                        Authorization: 'Bearer ' + User.jwt,
                                        },
                                    })
                                    .then(() => {
                                        dispatch(changeBlockEdit(!AdvanceReportED.BlockEdit))
                                    })
                                    .catch(() => {
                                        alert('Ошибка сохранения данных о остатке на начало месяца, повторите ввод.')                                    
                                    })
                                    .finally(() => {
                                        setLoadingLocker(true)
                                    })
                                }
                            })}              
                            >                               
                            {isLoadingLocker 
                            ? 
                            AdvanceReportED.BlockEdit ? <FaLock /> : <FaLockOpen />
                            : 
                            <div
                            className="MiniSpinLocker"
                            />
                            }
                            </button>                            
                            }
                            {[roleId.admin, roleId.operatingDirector].includes(User.user.role.id) &&
                            <>
                            {SelectedCity.id !== 0 &&
                                <button
                                className="ButtonArticle Long"
                                onClick={(() => {
                                    setModalDeleteCity(true)
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                        setModalDeleteCity(true)
                                })}
                                >
                                    Удалить филиал
                                </button>
                            }

                            {SelectedMonthAR.id !== 0 &&
                                <button
                                className="ButtonArticle Long"
                                onClick={(() => {
                                    setModalDeleteMonth(true)
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                        setModalDeleteMonth(true)
                                })}
                                >
                                    Удалить месяц
                                </button>
                            }
                            </>
                            }
                        </div>
                    </div>

                    <div
                    className="ARInformationDiv"
                    >
                        {SelectedCity.id !== 0 && SelectedMonthAR.id !== 0 && isLoadingAdvanceReport && AdvanceReportED.ResponsiblesUsers &&
                        <>
                            <div
                            className="ARInformationInputMainDiv"
                            >
                                <div
                                className="ARInformationInputDiv AndButton"
                                >
                                    <div>
                                        Остаток на начало месяца: 
                                    </div>                                    
                                    {[roleId.admin, roleId.operatingDirector, roleId.director].includes(User.user.role.id) && 
                                    <div
                                    className="ButtonSelectTransactionTypeDiv"
                                    >
                                        <button
                                        className={SelectTransactionType === 'Cash' ? 'ButtonSelectTransactionType Active' : 'ButtonSelectTransactionType'}
                                        onClick={(() => {
                                            if(SelectTransactionType !== 'Cash')
                                                setSelectTransactionType('Cash')
                                        })}
                                        onTouchStart={() => {
                                            setCancelTouch(false)
                                        }}
                                        onTouchMove={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchCancel={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchEnd={((event) => {
                                            event.preventDefault() 
                                            if(!CancelTouch)
                                            {
                                                if(SelectTransactionType !== 'Cash')
                                                    setSelectTransactionType('Cash')
                                            }
                                        })}
                                        >
                                            Нал
                                        </button>

                                        <button
                                        className={SelectTransactionType === 'NonCash' ? 'ButtonSelectTransactionType NonCash Active' : 'ButtonSelectTransactionType NonCash'}
                                        onClick={(() => {
                                            if(SelectTransactionType !== 'NonCash')
                                                setSelectTransactionType('NonCash')
                                        })}
                                        onTouchStart={() => {
                                            setCancelTouch(false)
                                        }}
                                        onTouchMove={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchCancel={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchEnd={((event) => {
                                            event.preventDefault() 
                                            if(!CancelTouch)
                                            {
                                                if(SelectTransactionType !== 'NonCash')
                                                    setSelectTransactionType('NonCash')
                                            }
                                        })}
                                        >
                                            Безнал
                                        </button>
                                    </div>
                                    }
                                </div>

                                <div
                                className="ARInformationInputDiv"
                                >
                                    {!isLoadingBalanceBeginningCash && 
                                    <div
                                    className="MiniSpinED"
                                    />
                                    }
                                    {SelectTransactionType === 'Cash' &&
                                    <input
                                    className="CashInputAR EnteringData"
                                    type="number"
                                    id="CashInputAR Beginning"
                                    placeholder="Остаток на начало месяца"
                                    defaultValue={BalanceBeginningCash}
                                    onClick={(() => {
                                        if(AdvanceReportED.BlockEdit)
                                        {
                                            document.getElementById("CashInputAR Beginning").blur()
                                            alert('Измненеие данных закрыто')
                                        }
                                    })}
                                    onTouchStart={() => {
                                        setCancelTouch(false)
                                    }}
                                    onTouchMove={() => {
                                        setCancelTouch(true)
                                    }}
                                    onTouchCancel={() => {
                                        setCancelTouch(true)
                                    }}
                                    onTouchEnd={((event) => {
                                        event.preventDefault() 
                                        if(!CancelTouch)
                                        {
                                            if(AdvanceReportED.BlockEdit)
                                            {
                                                document.getElementById("CashInputAR Beginning").blur()
                                                alert('Измненеие данных закрыто')
                                            }
                                            else
                                            {
                                                document.getElementById("CashInputAR Beginning").focus()
                                            }
                                        }
                                    })}
                                    onChange={((e) => {
                                        if(e.target.value !== '')
                                        {
                                            setBalanceBeginningCash(parseFloat(e.target.value))
                                        }
                                        else
                                        {
                                            setBalanceBeginningCash(parseFloat(0))
                                        }
                                    })}
                                    onBlur={(async () => {
                                        if(!AdvanceReportED.BlockEdit)
                                            if(BalanceBeginningCash !== AdvanceReportED.BalanceBeginningMonthCash)
                                            {
                                                setLoadingBalanceBeginningCash(false)                                        
                                                await axios.put(Server + 'cityadvancereports/' + AdvanceReportED.id, {
                                                    BalanceBeginningMonthCash: BalanceBeginningCash,
                                                }, {
                                                    headers: {
                                                    Authorization: 'Bearer ' + User.jwt,
                                                    },
                                                })
                                                .then(() => {
                                                    setLoadingBalanceBeginningCash(true)
                                                    dispatch(changeBalanceBeginningMonthCash(BalanceBeginningCash))
                                                })
                                                .catch(() => {
                                                    alert('Ошибка сохранения данных о остатке на начало месяца, повторите ввод.')
                                                    setBalanceBeginningCash(parseFloat(AdvanceReportED.BalanceBeginningMonthCash))
                                                    document.getElementById('CashInputAR Beginning').value = parseFloat(AdvanceReportED.BalanceBeginningMonthCash)
                                                    setLoadingBalanceBeginningCash(true)
                                                })
                                            }
                                    })}
                                    />
                                    }

                                    {SelectTransactionType === 'NonCash' &&
                                    <input
                                     className="CashInputAR EnteringData"
                                    type="number"
                                    id="NonCashInputAR Beginning"
                                    placeholder="Остаток на начало месяца"
                                    defaultValue={BalanceBeginningNonCash}
                                    onClick={(() => {
                                        if(AdvanceReportED.BlockEdit)
                                        {
                                            document.getElementById("NonCashInputAR Beginning").blur()
                                            alert('Измненеие данных закрыто')
                                        }
                                    })}
                                    onTouchStart={() => {
                                        setCancelTouch(false)
                                    }}
                                    onTouchMove={() => {
                                        setCancelTouch(true)
                                    }}
                                    onTouchCancel={() => {
                                        setCancelTouch(true)
                                    }}
                                    onTouchEnd={((event) => {
                                        event.preventDefault() 
                                        if(!CancelTouch)
                                        {
                                            if(AdvanceReportED.BlockEdit)
                                            {
                                                document.getElementById("NonCashInputAR Beginning").blur()
                                                alert('Измненеие данных закрыто')
                                            }
                                            else
                                            {
                                                document.getElementById("NonCashInputAR Beginning").focus()
                                            }
                                        }
                                    })}
                                    onChange={((e) => {
                                        if(e.target.value !== '')
                                        {
                                            setBalanceBeginningNonCash(parseFloat(e.target.value))
                                        }
                                        else
                                        {
                                            setBalanceBeginningNonCash(parseFloat(0))
                                        }
                                    })}
                                    onBlur={(async () => {
                                        if(!AdvanceReportED.BlockEdit)
                                            if(BalanceBeginningNonCash !== AdvanceReportED.BalanceBeginningMonthNonCash)
                                            {
                                                setLoadingBalanceBeginningCash(false)                                        
                                                await axios.put(Server + 'cityadvancereports/' + AdvanceReportED.id, {
                                                    BalanceBeginningMonthNonCash: BalanceBeginningNonCash,
                                                }, {
                                                    headers: {
                                                    Authorization: 'Bearer ' + User.jwt,
                                                    },
                                                })
                                                .then(() => {
                                                    setLoadingBalanceBeginningCash(true)
                                                    dispatch(changeBalanceBeginningMonthNonCash(BalanceBeginningNonCash))
                                                })
                                                .catch(() => {
                                                    alert('Ошибка сохранения данных о остатке на начало месяца, повторите ввод.')
                                                    setBalanceBeginningNonCash(parseFloat(AdvanceReportED.BalanceBeginningMonthCash))
                                                    document.getElementById('NonCashInputAR Beginning').value = parseFloat(AdvanceReportED.BalanceBeginningMonthNonCash)
                                                    setLoadingBalanceBeginningCash(true)
                                                })
                                            }
                                    })}
                                    />
                                    }
                                </div>
                            </div>

                            <div
                            className="ARInformationInputMainDiv"
                            >
                                <div
                                className="ARInformationInputDiv AndButton"
                                >
                                    <div>
                                        Остаток на конец месяца: 
                                    </div>
                                    {[roleId.admin, roleId.operatingDirector, roleId.director].includes(User.user.role.id) && 
                                    <div
                                    className="ButtonSelectTransactionTypeDiv"
                                    >
                                    <button
                                        className={SelectTransactionType === 'Cash' ? 'ButtonSelectTransactionType Active' : 'ButtonSelectTransactionType'}
                                        onClick={(() => {
                                            if(SelectTransactionType !== 'Cash')
                                                setSelectTransactionType('Cash')
                                        })}
                                        onTouchStart={() => {
                                            setCancelTouch(false)
                                        }}
                                        onTouchMove={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchCancel={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchEnd={((event) => {
                                            event.preventDefault() 
                                            if(!CancelTouch)
                                            {
                                                if(SelectTransactionType !== 'Cash')
                                                    setSelectTransactionType('Cash')
                                            }
                                        })}
                                        >
                                            Нал
                                        </button>

                                        <button
                                        className={SelectTransactionType === 'NonCash' ? 'ButtonSelectTransactionType NonCash Active' : 'ButtonSelectTransactionType NonCash'}
                                        onClick={(() => {
                                            if(SelectTransactionType !== 'NonCash')
                                                setSelectTransactionType('NonCash')
                                        })}
                                        onTouchStart={() => {
                                            setCancelTouch(false)
                                        }}
                                        onTouchMove={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchCancel={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchEnd={((event) => {
                                            event.preventDefault() 
                                            if(!CancelTouch)
                                            {
                                                if(SelectTransactionType !== 'NonCash')
                                                    setSelectTransactionType('NonCash')
                                            }
                                        })}
                                        >
                                            Безнал
                                        </button>
                                    </div>
                                    }
                                </div>

                                <div
                                className="ARInformationInputDiv"
                                >
                                    {SelectTransactionType === 'Cash' &&
                                    <input
                                    className="CashInputAR EnteringData"
                                    id='CashInputAR End'
                                    placeholder="Остаток на конец месяца"
                                    value={BalanceEndCash}
                                    onFocus={(() => {
                                        document.getElementById('CashInputAR End').blur()
                                    })}
                                    />
                                    }

                                    {SelectTransactionType === 'NonCash' &&
                                    <input
                                    className="CashInputAR EnteringData"
                                    id='NonCashInputAR End'
                                    placeholder="Остаток на конец месяца"
                                    value={BalanceEndNonCash}
                                    onFocus={(() => {
                                        document.getElementById('NonCashInputAR End').blur()
                                    })}
                                    />
                                    }
                                </div>
                            </div>

                            <div
                            className="ARInformationInputMainDiv ResponsiblesUsers"
                            >
                                <div
                                className="ARInformationInputDiv"
                                >
                                    <span className="ARInformationInputText">{'Ответственный: '}</span>
                                    {AdvanceReportED.ResponsiblesUsers.ManagerName}
                                </div>

                                <div
                                className="ARInformationInputDiv"
                                >
                                    <span className="ARInformationInputText">{'Бухгалтер: '}</span>
                                    {AdvanceReportED.ResponsiblesUsers.AccountantName}
                                </div>
                            </div>
                        </>
                        }
                    </div>

                    {SelectedCity.id !== 0 && SelectedMonthAR.id !== 0 && isLoadingAdvanceReport && FilterArticles &&
                    <div
                    className="ARInformationDiv Column"
                    >
                        {User.user.role.id !== roleId.accountant && 
                        <div
                        className="ViewIndicatorAndButtonDiv"
                        >
                            <div
                            className="TotalViewIndicatorMainDiv"
                            >
                                <div
                                className="TotalViewIndicatorMainDivUnder"
                                >
                                    <div
                                    className="TotalViewOneIndicatorDiv"
                                    >
                                        {'Итого нал:'}
                                    </div>
                                    <div
                                    className="TotalViewOneIndicatorDiv"
                                    >
                                        {'Доход: ' + IncomeCash}
                                    </div>
                                </div>

                                <div
                                className="TotalViewIndicatorMainDivUnder"
                                >
                                    <div
                                    className="TotalViewOneIndicatorDiv"
                                    >
                                        {'Расход: ' + ExpenditureCash}
                                    </div>
                                    <div
                                    className="TotalViewOneIndicatorDiv Collection"
                                    >
                                        {'Внесение "+"/Инкассация "-": ' + CollectionCash}
                                    </div>
                                </div>
                            </div>

                            <div
                            className="ButtonArticleDiv"
                            >
                                <button
                                className="ButtonArticle"
                                onClick={(() => {
                                    if(AdvanceReportED.BlockEdit)
                                        return(alert('Измненеие данных закрыто'))

                                    let CheckId = 1
                                    if(AdvanceReportED.Articles.length > 0)
                                    {
                                        CheckId = parseFloat(AdvanceReportED.Articles[AdvanceReportED.Articles.length - 1].id) + 1                                        
                                    }
                                    dispatch(addTypeArticleInAR({id: CheckId, Type: 'income', TransactionType: 'Cash', User: User.user.FIO, MonthValue: AdvanceReportED.MonthValue, YearValue: AdvanceReportED.YearValue}))
                                    dispatch(setOpenAddArticleED(true))
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        if(AdvanceReportED.BlockEdit)
                                            return(alert('Измненеие данных закрыто'))

                                        let CheckId = 1
                                        if(AdvanceReportED.Articles.length > 0)
                                        {
                                            CheckId = parseFloat(AdvanceReportED.Articles[AdvanceReportED.Articles.length - 1].id) + 1
                                        }
                                        dispatch(addTypeArticleInAR({id: CheckId, Type: 'income', TransactionType: 'Cash', User: User.user.FIO, MonthValue: AdvanceReportED.MonthValue, YearValue: AdvanceReportED.YearValue}))
                                        dispatch(setOpenAddArticleED(true))
                                    }
                                })}
                                >
                                    + Доход
                                </button>
                                <button
                                className="ButtonArticle"
                                onClick={(() => {
                                    if(AdvanceReportED.BlockEdit)
                                        return(alert('Измненеие данных закрыто'))

                                    let CheckId = 1
                                    if(AdvanceReportED.Articles.length > 0)
                                    {
                                        CheckId = parseFloat(AdvanceReportED.Articles[AdvanceReportED.Articles.length - 1].id) + 1
                                    }
                                    dispatch(addTypeArticleInAR({id: CheckId, Type: 'expenditure', TransactionType: 'Cash', User: User.user.FIO, MonthValue: AdvanceReportED.MonthValue, YearValue: AdvanceReportED.YearValue}))
                                    dispatch(setOpenAddArticleED(true))
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        if(AdvanceReportED.BlockEdit)
                                            return(alert('Измненеие данных закрыто'))

                                        let CheckId = 1
                                        if(AdvanceReportED.Articles.length > 0)
                                        {
                                            CheckId = parseFloat(AdvanceReportED.Articles[AdvanceReportED.Articles.length - 1].id) + 1
                                        }
                                        dispatch(addTypeArticleInAR({id: CheckId, Type: 'expenditure', TransactionType: 'Cash', User: User.user.FIO, MonthValue: AdvanceReportED.MonthValue, YearValue: AdvanceReportED.YearValue}))
                                        dispatch(setOpenAddArticleED(true))
                                    }
                                })}
                                >
                                    + Расход
                                </button>
                                <button
                                className="ButtonArticle"
                                onClick={(() => {
                                    if(AdvanceReportED.BlockEdit)
                                        return(alert('Измненеие данных закрыто'))

                                    let CheckId = 1
                                    if(AdvanceReportED.Articles.length > 0)
                                    {
                                        CheckId = parseFloat(AdvanceReportED.Articles[AdvanceReportED.Articles.length - 1].id) + 1
                                    }
                                    dispatch(addTypeArticleInAR({id: CheckId, Type: 'collection', TransactionType: 'Cash', User: User.user.FIO, MonthValue: AdvanceReportED.MonthValue, YearValue: AdvanceReportED.YearValue}))
                                    dispatch(setOpenAddArticleED(true))
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        if(AdvanceReportED.BlockEdit)
                                            return(alert('Измненеие данных закрыто'))

                                        let CheckId = 1
                                        if(AdvanceReportED.Articles.length > 0)
                                        {
                                            CheckId = parseFloat(AdvanceReportED.Articles[AdvanceReportED.Articles.length - 1].id) + 1
                                        }
                                        dispatch(addTypeArticleInAR({id: CheckId, Type: 'collection', TransactionType: 'Cash', User: User.user.FIO, MonthValue: AdvanceReportED.MonthValue, YearValue: AdvanceReportED.YearValue}))
                                        dispatch(setOpenAddArticleED(true))
                                    }
                                })}
                                >
                                    + Инкассация
                                </button>
                            </div>
                        </div>
                        }

                        {User.user.role.id !== roleId.manager &&
                        <div
                        className="ViewIndicatorAndButtonDiv"
                        >
                            <div
                            className="TotalViewIndicatorMainDiv"
                            >
                                <div
                                className="TotalViewIndicatorMainDivUnder"
                                >
                                    <div
                                    className="TotalViewOneIndicatorDiv"
                                    >
                                        {'Итого безнал:'}
                                    </div>
                                    <div
                                    className="TotalViewOneIndicatorDiv"
                                    >
                                        {'Доход: ' + IncomeNonCash}
                                    </div>
                                </div>
                                <div
                                className="TotalViewOneIndicatorDiv"
                                >
                                    {'Расход: ' + ExpenditureNonCash}
                                </div>
                            </div>

                            <div
                            className="ButtonArticleDiv"
                            >
                                <button
                                className="ButtonArticle"
                                onClick={(() => {
                                    if(AdvanceReportED.BlockEdit)
                                        return(alert('Измненеие данных закрыто'))

                                    let CheckId = 1
                                    if(AdvanceReportED.Articles.length > 0)
                                    {
                                        CheckId = parseFloat(AdvanceReportED.Articles[AdvanceReportED.Articles.length - 1].id) + 1
                                    }
                                    dispatch(addTypeArticleInAR({id: CheckId, Type: 'income', TransactionType: 'NonCash', User: User.user.FIO, MonthValue: AdvanceReportED.MonthValue, YearValue: AdvanceReportED.YearValue}))
                                    dispatch(setOpenAddArticleED(true))
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        if(AdvanceReportED.BlockEdit)
                                            return(alert('Измненеие данных закрыто'))

                                        let CheckId = 1
                                        if(AdvanceReportED.Articles.length > 0)
                                        {
                                            CheckId = parseFloat(AdvanceReportED.Articles[AdvanceReportED.Articles.length - 1].id) + 1
                                        }
                                        dispatch(addTypeArticleInAR({id: CheckId, Type: 'income', TransactionType: 'NonCash', User: User.user.FIO, MonthValue: AdvanceReportED.MonthValue, YearValue: AdvanceReportED.YearValue}))
                                        dispatch(setOpenAddArticleED(true))
                                    }
                                })}
                                >
                                    + Доход
                                </button>
                                <button
                                className="ButtonArticle"
                                onClick={(() => {
                                    if(AdvanceReportED.BlockEdit)
                                        return(alert('Измненеие данных закрыто'))

                                    let CheckId = 1
                                    if(AdvanceReportED.Articles.length > 0)
                                    {
                                        CheckId = parseFloat(AdvanceReportED.Articles[AdvanceReportED.Articles.length - 1].id) + 1
                                    }
                                    dispatch(addTypeArticleInAR({id: CheckId, Type: 'expenditure', TransactionType: 'NonCash', User: User.user.FIO, MonthValue: AdvanceReportED.MonthValue, YearValue: AdvanceReportED.YearValue}))
                                    dispatch(setOpenAddArticleED(true))
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        if(AdvanceReportED.BlockEdit)
                                            return(alert('Измненеие данных закрыто'))

                                        let CheckId = 1
                                        if(AdvanceReportED.Articles.length > 0)
                                        {
                                            CheckId = parseFloat(AdvanceReportED.Articles[AdvanceReportED.Articles.length - 1].id) + 1
                                        }
                                        dispatch(addTypeArticleInAR({id: CheckId, Type: 'expenditure', TransactionType: 'NonCash', User: User.user.FIO, MonthValue: AdvanceReportED.MonthValue, YearValue: AdvanceReportED.YearValue}))
                                        dispatch(setOpenAddArticleED(true))
                                    }
                                })}
                                >
                                    + Расход
                                </button>
                            </div>
                        </div>
                        }

                        {[roleId.admin, roleId.operatingDirector, roleId.director].includes(User.user.role.id) && 
                        <div
                        className="TotalViewIndicatorMainDiv"
                        >
                            <div
                            className="TotalViewIndicatorMainDivUnder"
                            >
                                <div
                                className="TotalViewOneIndicatorDiv"
                                >
                                    {'Итого:'}
                                </div>
                                <div
                                className="TotalViewOneIndicatorDiv"
                                >
                                    {'Доход: ' + IncomeTotal}
                                </div>
                            </div>
                            <div
                            className="TotalViewOneIndicatorDiv"
                            >
                                {'Расход: ' + ExpenditureTotal}
                            </div>
                        </div>
                        }
                    </div>
                    }
                    <div
                    className={(SelectedCity.id !== 0 && SelectedMonthAR.id !== 0 && isLoadingAdvanceReport && FilterArticles) ? "ArticleEDMainDiv" : "ArticleEDMainDiv NoneOutline"}
                    >
                    {!isLoadingAdvanceReport &&
                    <div
                    className="LoaderAdvanceReport"
                    >
                        <div
                        className="BigSpin AdvanceReport"
                        />
                    </div>
                    }

                    {SelectedCity.id !== 0 && SelectedMonthAR.id !== 0 && isLoadingAdvanceReport && FilterArticles &&
                    <>
                        {FilterArticles.length > 0 ? 
                        FilterArticles.map((el, index) => 
                        <div
                        key={index}
                        className={"OneArticleEDMain " + el.Type}
                        >
                            <div
                            className="OneArticleEDDiv Date"
                            >
                                {el.CreateAd.split('T')[0].split('-')[2] + '.' + el.CreateAd.split('T')[0].split('-')[1] + '.' + el.CreateAd.split('T')[0].split('-')[0]}
                            </div>

                            <div
                            className="OneArticleEDDiv Name"
                            >
                                {el.Name}
                            </div>
                            
                            <div
                            className="OneArticleEDDiv Sum"
                            >
                                {el.Sum}
                            </div>

                            <div
                            className="OneArticleEDDiv TransactionType"
                            >
                                {el.TransactionType === 'Cash' ? 'Нал' : 'Безнал'}
                            </div>

                            <div
                            className="OneArticleEDDiv ResponsibleUserName"
                            >
                                {el.ResponsibleUserName}
                            </div>

                            <div
                            className="OneArticleEDDiv Comment"
                            >
                                {el.Comment}
                            </div>

                            <div>
                                <button
                                className="FilterButtonAR Edit"
                                onClick={(() => {
                                    if(AdvanceReportED.BlockEdit)
                                        return(alert('Измненеие данных закрыто'))
                                    let elCreateAdDate = el.CreateAd.split('T')[0]
                                    let elCreateAdTime = el.CreateAd.split('T')[1]
                                    dispatch(openEditAddedArticle({
                                        id: el.id,
                                        idArticle: el.idArticle,
                                        Sum: el.Sum,
                                        Name: el.Name,
                                        ResponsibleUserName: el.ResponsibleUserName,
                                        OtherExpenditure: el.OtherExpenditure,
                                        TransactionType: el.TransactionType,
                                        Type: el.Type,
                                        Comment: el.Comment,
                                        CreateAdDate: elCreateAdDate,
                                        CreateAdTime: elCreateAdTime,
                                        AddAdminArticle: false,
                                        AddAdminOtherExpenditure: false,
                                        idCity: SelectedCity.id
                                    }))
                                    dispatch(setOpenAddArticleED(true))
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        if(AdvanceReportED.BlockEdit)
                                            return(alert('Измненеие данных закрыто'))

                                        let elCreateAdDate = el.CreateAd.split('T')[0]
                                        let elCreateAdTime = el.CreateAd.split('T')[1]
                                        dispatch(openEditAddedArticle({
                                            id: el.id,
                                            idArticle: el.idArticle,
                                            Sum: el.Sum,
                                            Name: el.Name,
                                            ResponsibleUserName: el.ResponsibleUserName,
                                            OtherExpenditure: el.OtherExpenditure,
                                            TransactionType: el.TransactionType,
                                            Type: el.Type,
                                            Comment: el.Comment,
                                            CreateAdDate: elCreateAdDate,
                                            CreateAdTime: elCreateAdTime,
                                            AddAdminArticle: false,
                                            AddAdminOtherExpenditure: false,
                                            idCity: SelectedCity.id
                                        }))
                                        dispatch(setOpenAddArticleED(true))
                                    }
                                })}
                                > 
                                    <FaPencil />
                                </button>
                            </div>
                        </div>
                        )
                    :
                    <div
                    className="NoneDataED"
                    >
                        Данных нет...
                    </div>
                    }
                    </>
                    }
                    </div>
                    
                </div>
            {ModalDeleteCity &&
            <div
            className="ModalChangeHiddenGlobalDiv"
            >
                <div
                className="ModalChangeHiddenMainDiv"
                >
                    <div>
                    {'Филиал ' + SelectedCity.City + ' ' + SelectedCity.Adress + ' и данные о нем будут удалены без возможности восстановления' }
                    </div>
                    <div
                    className="ModalChangeHiddenButtonsDiv"
                    >
                        <button
                        className="ModalChangeHiddenButton Cancle"
                        onClick={(() => {
                            setModalDeleteCity(false)
                        })}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                                setModalDeleteCity(false)
                        })}
                        >
                            Отмена
                        </button>
                        <button
                        className="ModalChangeHiddenButton Ok"
                        onClick={handleDeleteCity}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={(event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                                handleDeleteCity(event)
                        }}
                        >
                            Ок
                        </button>
                    </div>
                </div>
            </div>
            }

            {ModalDeleteMonth &&
            <div
            className="ModalChangeHiddenGlobalDiv"
            >
                <div
                className="ModalChangeHiddenMainDiv"
                >
                    <div>
                    {'Месяц ' + SelectedMonthAR.Name + ' и данные о нем будут удалены без возможности восстановления' }
                    </div>
                    <div
                    className="ModalChangeHiddenButtonsDiv"
                    >
                        <button
                        className="ModalChangeHiddenButton Cancle"
                        onClick={(() => {
                            setModalDeleteMonth(false)
                        })}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                                setModalDeleteMonth(false)
                        })}
                        >
                            Отмена
                        </button>
                        <button
                        className="ModalChangeHiddenButton Ok"
                        onClick={handleDeleteMonth}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={(event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                                handleDeleteMonth(event)
                        }}
                        >
                            Ок
                        </button>
                    </div>
                </div>
            </div>
            }
            </div>
        )
}

export default EnteringDataAR;